export class DirectoryInfo {
	team: string;
	description: string;
	id: number;
	isDefault: boolean;
	tenantId: number;
	defaultAppUserId: number;
}